/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { notifications } from '@mantine/notifications';

// I18n
import { useTranslation } from 'react-i18next';

// Types
import { IApiError } from '@global-types/index';
import { TBodyApi, TResponseApi } from 'shared/types';
import { TMutationConfig } from '@lib/react-query';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const uploadPicture = (
	data: TBodyApi
): Promise<{
	id: string;
	response: TResponseApi;
}> => {
	return apiClient.post('/public/media', data);
};

type TUseUploadPictureOptions = {
	mutationConfig?: TMutationConfig<typeof uploadPicture>;
};

export const useUploadPicture = ({
	mutationConfig,
}: TUseUploadPictureOptions = {}) => {
	const { onSuccess, ...restConfig } =
		mutationConfig || {};

	const {
		mutate,
		isPending: isLoading,
		isSuccess,
		data,
	} = useMutation({
		mutationFn: uploadPicture,
		onSuccess: (...args) => {
			onSuccess?.(...args);
		},
		...restConfig,
	});

	return { mutate, isLoading, isSuccess, data };
};
